import { NgModule } from '@angular/core';

import { LocalizedDatePipe } from '../app/components/pipes/localized-date.pipe';
import { TableValuePipe } from './components/pipes/table-value.pipe';
import { EnumKeysPipe } from 'src/utils/Enum.Pipe';
import { IsOptionSelected } from 'src/utils/surveyReponse.Pipe';
import { InjectHyperlinkPipe } from './components/pipes/inject-hyperlink.pipe';

const PIPES = [
    LocalizedDatePipe,
    TableValuePipe,
    EnumKeysPipe,
    InjectHyperlinkPipe,
    IsOptionSelected
];

@NgModule({
    imports: [],
    declarations: [...PIPES],
    providers: [],
    exports: [...PIPES]
})
export class PipesModule {
}